export default {
    "template": "componentsCompany/cian/CompanySettings",
    "default_number_format": {
        "decimal_point": ",",
        "decimal_length": 2
    },
    "new_design": true,
    "menu_template": "componentsCompany/cian/header/MenuComponent",
    "paginator": {
        "per_page_sizes": [
            10,
            25,
            50,
            100
        ],
        "per_page_default": 50
    }
}